import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useMutation } from "react-relay";
import { type accountSwitcher_SwitchAccountMutation } from "@relay/accountSwitcher_SwitchAccountMutation.graphql";
import { SWITCH_ACCOUNT_MUTATION } from "./account-switcher.graphql";
import { setAppTokens, selectAppRefreshToken } from "../../store/slices/AuthSlice";
import { selectCurrentUser } from "../../store/slices/CurrentUserSlice";

export const AccountSwitcher = () => {
	const currentUser = useSelector(selectCurrentUser);
	const refreshToken = useSelector(selectAppRefreshToken);
	const [commit, isInFlight] =
		useMutation<accountSwitcher_SwitchAccountMutation>(SWITCH_ACCOUNT_MUTATION);
	const dispatch = useDispatch();

	const accounts = currentUser?.accounts || [];
	const [selectedAccountId, setSelectedAccountId] = useState<string | null>(null);

	const handleSwitch = () => {
		if (!selectedAccountId || !refreshToken) {
			return;
		}

		commit({
			variables: {
				input: {
					targetAccount: selectedAccountId,
					refreshToken: refreshToken,
				},
			},
			onCompleted: (response) => {
				const tokens = response.Auth.switchAccount?.jwtTokens;
				if (tokens?.accessToken && tokens?.refreshToken) {
					// Store both tokens
					dispatch(
						setAppTokens({
							accessToken: tokens.accessToken,
							refreshToken: tokens.refreshToken,
						}),
					);
					// Reload to get new permissions
					window.location.reload();
				}
			},
			onError: () => {},
		});
	};

	if (accounts.length <= 1) {
		return null;
	}

	const accountOptions = accounts.map((account) => ({
		label: `${account.name} (${account.id})`,
		value: account.id,
	}));

	return (
		<div style={{ display: "flex", gap: "0.5rem", alignItems: "center", padding: "1rem" }}>
			<span>Switch Account:</span>
			<Dropdown
				value={selectedAccountId}
				options={accountOptions}
				onChange={(e) => setSelectedAccountId(e.value)}
				placeholder="Select an account"
				style={{ width: "300px" }}
			/>
			<Button
				label="Switch"
				onClick={handleSwitch}
				disabled={!selectedAccountId || !refreshToken || isInFlight}
				loading={isInFlight}
			/>
		</div>
	);
};
